import React from 'react';
import './App.css';
import AuroraSidePanel from './AuroraSidePanel';
import { Provider, teamsTheme } from '@fluentui/react-northstar';

function App() {

  return (
    <Provider theme={teamsTheme}>
      <div className="app-container">
        <AuroraSidePanel />
      </div>
    </Provider>
  );
}

export default App;
